import { existsSync, readFileSync } from 'node:fs';
import { dirname, join } from 'node:path';
import { fileURLToPath } from 'node:url';

/**
 * Read a migration SQL file. `searchSubdirs` are tried relative to this module and common dist layouts
 * (e.g. `migrations` for the main CLI DB, `code-nav-cache-migrations` for the cache DB).
 */
export function readMigrationSql(filename: string, ...searchSubdirs: string[]): string {
  const moduleDir = dirname(fileURLToPath(import.meta.url));
  const candidates = searchSubdirs.flatMap((sub) => [
    join(moduleDir, sub, filename),
    join(moduleDir, '..', sub, filename),
    join(moduleDir, '..', '..', 'dist', sub, filename),
  ]);
  const resolved = candidates.find((path) => existsSync(path));
  if (!resolved) {
    throw new Error(`Missing SQLite migration SQL: ${filename} (searched ${searchSubdirs.join(', ')})`);
  }
  return readFileSync(resolved, 'utf8');
}

/** @alias {@link readMigrationSql} with `migrations` search dir (main CLI DB). */
export function readCliSqliteMigrationSql(filename: string): string {
  return readMigrationSql(filename, 'migrations');
}

/** @alias {@link readMigrationSql} with code-nav cache migration search dirs. */
export function readCodeNavCacheMigrationSql(filename: string): string {
  return readMigrationSql(filename, 'code-nav-cache-migrations', 'code-nav-cache/migrations');
}
